var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon icon--tick",attrs:{"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 10.8L3.2 8l-1 1L6 12.6l8-8-1-1-7 7.1z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }